module.exports = __webpack_public_path__ + "github-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/github-logo.png
// module id = 1255
// module chunks = 74